export const normalizeUrl = (url) => {
    if (!url) return '';
    try {
        return new URL(url).toString().replace(/\/$/, '');
    } catch {
        return url.replace(/\/$/, '');
    }
};
